module.exports = __webpack_public_path__ + "static/TFF_Barkingowl-7606f9a1a8763e25c6c2ab97f1dbc973.jpg";